// eslint-disable-next-line no-restricted-imports
import type { NotificationGroupResponse } from 'app/gamma/src/types/responses';
import type { ReactionResponse } from './Reactions.types';
import { convertReactionToClientFormat } from './convertReactionToClientFormat';
import { reactionsState } from './reactionsState';
import { flatten } from 'underscore';

const normalizeReactionsFromNotificationGroups = (
  notificationGroups: {
    notifications: {
      reactions: ReactionResponse[];
    }[];
  }[],
) => {
  return flatten(
    notificationGroups.map((notificationGroup) =>
      flatten(
        notificationGroup.notifications.map((notification) =>
          notification.reactions.map((reaction) =>
            convertReactionToClientFormat(reaction),
          ),
        ),
      ),
    ),
  );
};

export const loadReactionsFromNotifications = (
  notificationGroupsResponse: NotificationGroupResponse[],
) => {
  const reactionsModel = normalizeReactionsFromNotificationGroups(
    notificationGroupsResponse,
  );
  reactionsModel.forEach((reactionModel) => {
    const idModel = reactionModel.idModel;

    if (!reactionsState.value.reactions[idModel]) {
      reactionsState.setValue({
        ...reactionsState.value,
        reactions: {
          ...reactionsState.value.reactions,
          [idModel]: [],
        },
      });
    }

    if (
      !reactionsState.value.reactions[idModel].some(
        (reaction) => reaction.id === reactionModel.id,
      )
    ) {
      reactionsState.setValue({
        ...reactionsState.value,
        reactions: {
          ...reactionsState.value.reactions,
          [idModel]: [
            ...reactionsState.value.reactions[idModel],
            reactionModel,
          ],
        },
      });
    }
  });
};
